'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463 from "./presto.types$-Directive-Path$$anon$63.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464 from "./presto.types$-Directive-Path$$anon$64.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectivePath$() {
  this.c5G = null;
  this.c5H = false;
  this.c5E = null;
  this.c5F = false;
  this.c5K = null;
  this.c5L = false;
  this.c5I = null;
  this.c5J = false;
  this.c5M = null;
  this.c5N = false;
}
export { $c_Lpresto_types$DirectivePath$ as $c_Lpresto_types$DirectivePath$ };
$p = $c_Lpresto_types$DirectivePath$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectivePath$;
/** @constructor */
function $h_Lpresto_types$DirectivePath$() {
}
export { $h_Lpresto_types$DirectivePath$ as $h_Lpresto_types$DirectivePath$ };
$h_Lpresto_types$DirectivePath$.prototype = $p;
$p.cHY = (function() {
  if ((!this.c5H)) {
    this.c5G = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c5H = true;
  }
  return this.c5G;
});
$p.v6 = (function() {
  if ((!this.c5F)) {
    this.c5E = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5F = true;
  }
  return this.c5E;
});
$p.cIH = (function() {
  if ((!this.c5L)) {
    this.c5K = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5L = true;
  }
  return this.c5K;
});
$p.csa = (function() {
  if ((!this.c5J)) {
    this.c5I = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463.$c_Lpresto_types$DirectivePath$$anon$63(this);
    this.c5J = true;
  }
  return this.c5I;
});
$p.cIX = (function() {
  if ((!this.c5N)) {
    this.c5M = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464.$c_Lpresto_types$DirectivePath$$anon$64(this);
    this.c5N = true;
  }
  return this.c5M;
});
var $d_Lpresto_types$DirectivePath$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectivePath$, "presto.types$DirectivePath$", ({
  ZB: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectivePath$ as $d_Lpresto_types$DirectivePath$ };
var $n_Lpresto_types$DirectivePath$;
function $m_Lpresto_types$DirectivePath$() {
  if ((!$n_Lpresto_types$DirectivePath$)) {
    $n_Lpresto_types$DirectivePath$ = new $c_Lpresto_types$DirectivePath$();
  }
  return $n_Lpresto_types$DirectivePath$;
}
export { $m_Lpresto_types$DirectivePath$ as $m_Lpresto_types$DirectivePath$ };
//# sourceMappingURL=presto.types$-Directive-Path$.js.map
